var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.24609 9.35954V3.24414H3.24609V9.35954C3.24609 10.4641 4.14152 11.3595 5.24609 11.3595H9.73866V10.3595H5.24609C4.69381 10.3595 4.24609 9.91183 4.24609 9.35954ZM16.8538 3.24483H17.8538V3.24414H16.8538V3.24483Z",
    fill: "#3E3D3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6074 1.99983L14.6074 8.11523L15.6074 8.11523L15.6074 1.99984C15.6074 0.895266 14.712 -0.000165064 13.6074 -0.000165161L9.11508 -0.000165553L9.11508 0.999834L13.6074 0.999835C14.1597 0.999835 14.6074 1.44755 14.6074 1.99983ZM1.9997 8.11477L0.999702 8.11477L0.999702 8.11523L1.9997 8.11523L1.9997 8.11477Z",
    fill: "#3E3D3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0742 5.05521C12.8285 4.80712 12.43 4.80712 12.1843 5.05521C11.9386 5.30329 11.9386 5.70552 12.1843 5.95361L14.6819 8.47504C14.7061 8.49954 14.7319 8.52163 14.7589 8.54129C15.0005 8.74003 15.3568 8.72573 15.582 8.49839L18.1154 5.94082C18.3557 5.69822 18.3557 5.30489 18.1154 5.0623C17.8751 4.8197 17.4855 4.8197 17.2452 5.0623L15.1632 7.16417L13.0742 5.05521Z",
    fill: "#3E3D3D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9258 6.24948C6.17154 6.49757 6.56996 6.49757 6.8157 6.24948C7.06143 6.0014 7.06143 5.59917 6.8157 5.35108L4.31813 2.82965C4.29386 2.80514 4.26809 2.78306 4.24114 2.7634C3.99946 2.56466 3.64316 2.57896 3.41798 2.8063L0.884613 5.36387C0.644312 5.60646 0.644312 5.99979 0.884613 6.24239C1.12491 6.48499 1.51452 6.48499 1.75482 6.24239L3.8368 4.14052L5.9258 6.24948Z",
    fill: "#3E3D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.ca6f9bee6bbc8d03aa08d03a37e85826.svg";
export { ForwardRef as ReactComponent };